<template>
    <div>
        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />
        <PageTitle v-bind:title="title" v-bind:admin="true" />

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>

        <Loader v-if="loading" />
        <div v-else-if="data.id">






            <hr>
            <p>Фото кафедры:</p>
            <!-- <button @click="testtest">1243</button> -->
            <img v-if="data.image" :src="data.image" alt="" height="300" class="shadow">
            <p v-else class="alert alert-info">Необходимо загрузить изображение:</p>
            <form @submit.prevent="submit">
                <!-- <div class="form-group">
                    <input type="text" class="form-control" placeholder="Name" v-model="name">
                </div> -->
                <div class="form-group">
                    <div class="custom-file">
                        <input type="file"
                            class="custom-file-input"
                            id="customFile"
                            @change="onAttachmentChange"
                        >
                        <label class="custom-file-label" for="customFile">Выберите файл для загрузки</label>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-primary">Сохранить фото</button>
                </div>
                <div class="alert alert-danger" v-if="errors.uploadfile">
                    {{ errors.uploadfile }}
                </div>
            </form>
            <hr>




            <form>
                <input type="hidden" name="id" v-model="data.id">
                <div class="form-group">
                    <label for="name" class="col-form-label">Наименование:</label>
                    <input type="text" class="form-control" id="name" name="name" v-model="data.name">
                    <div class="alert alert-danger" v-if="errors.validationEdit && errors.validationEdit.name">
                        {{ errors.validationEdit.name[0] }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="description" class="col-form-label">Описание:</label>
                    <textarea class="form-control" name="description" id="description" cols="30" rows="10" v-model="data.description"></textarea>
                    <div class="alert alert-danger" v-if="errors.validationEdit && errors.validationEdit.description">
                        {{ errors.validationEdit.description[0] }}
                    </div>
                </div>
            </form>
            <button type="button" class="btn btn-primary" @click.prevent="editRecord()">Сохранить изменения</button>
            <div class="alert alert-danger" v-if="errors.edit">
                {{ errors.edit }}
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import BreadCrumbs from '@/components/BreadCrumbs'
import PageTitle from '@/components/PageTitle'
export default {


    data() {
        return {
            loading: true,
            data: [],
            errors: {load: '', edit: '', validationEdit: {}, uploadfile: ''},
            bcrumbs: [],
            title: 'Редактирование Кафедры',
            attachment: null,
        }
    },


    async mounted() {
       this.loadData()
    },

    methods: {
        async loadData() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/departments/'+this.$route.params.id+'/edit')
                this.data = response.data.department
                this.bcrumbs = response.data.bcrumbs
                this.loading = false
            }
            catch (e) {
                if (e.response.status == 401) {
                    this.errors.load = 'Нет доступа.'
                }               
                else {
                    this.errors.load = 'Ошибка при загрузке данных'
                }
            }
        },


        onAttachmentChange (e) {
            this.attachment = e.target.files[0]
        },

/*
        async testtest()
        {
            this.errors.uploadfile = ''

            const config = { 'content-type': 'multipart/form-data' }
            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('attachment', this.attachment)





            try {
                // alert(9)
                //let response = await axios.post('admin/departments/'+this.data.id,  Object.assign(this.data, {_method: 'PUT'}))
                 //let response = await axios.post('test/upload4/'+this.data.id, formData, config)


                //let response = await axios.post('admin/departments/'+this.data.id+'/departmentUploadImage', formData, config)  // работает!!!
                let response = await axios.post('admin/departments/'+this.data.id+'/departmentUploadImage', formData, config)
                

                console.log(response)
            }
            catch (e) {
                console.log('ERRR')
            }
        },
*/
        submit () 
        {
            this.errors.uploadfile = ''
            const config = { 'content-type': 'multipart/form-data' }
            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('attachment', this.attachment)

            axios.post('admin/departments/'+this.data.id+'/departmentUploadImage', formData, config)
                .then(response => {
                    this.data.image = response.data.image
                    //console.log(response);
                })
                .catch(error => {
                    if (error.response.status == 520) {
                        this.errors.uploadfile = error.response.data.error
                    }
                    if (error.response.status == 422) {
                        this.errors.uploadfile = error.response.data.errors.attachment[0]
                    }
                    else {
                        this.errors.uploadfile = 'Неизвестная ошибка при загрузке файла.'
                    }
                })
        },



        //
        // Edit record.
        //
        async editRecord() {
            this.errors.validationEdit = {}
            this.errors.edit = ''
            try {
                //let response = await axios.post('admin/courses/'+this.data.id, {id: this.data.id, name: this.data.name, description: this.data.description, department_id: this.data.department_id, _method: 'PUT'})
                let response = await axios.post('admin/departments/'+this.data.id,  Object.assign(this.data, {_method: 'PUT'}))
                if (response.status == 200) {
                    this.loadData()
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationEdit = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.edit = e.response.data.error
                }
                else {
                    this.errors.edit = "Неизвестная ошибка при редактировании записи."
                }
            }
        },


    },

    components: {
        Loader,
        BreadCrumbs,
        PageTitle,
    },


  
}

</script>